import React from "react";
import Carousel from "../framework/carousel/Carousel";
import classes from "./Login.module.css";
import { slides } from "./LoginConstants";
import LoginForm from "./LoginForm";
const Login = () => {
  return (
    <>
      <div className={classes["login-container"]}>
        <div className={classes["login-form"]}>
          <LoginForm />
        </div>
        <div className={classes["login-carousel"]}>
          <Carousel slides={slides} />
        </div>
      </div>
    </>
  );
};

export default Login;
